import SourceDataDetails, { ISourceDataDetailsProps } from "@/components/details/SourceDataDetails";
import { FC } from "react";

interface ISourceDataFindingDetailsProps extends ISourceDataDetailsProps {
}


const SourceDataFindingDetails: FC<ISourceDataFindingDetailsProps> = (props) => {
    return (
        <SourceDataDetails {...props} />
    )
}

export default SourceDataFindingDetails;